import { useDispatch, useSelector } from 'react-redux'
import useQueryParams from '../common/hooks/useQueryParams'
import { ONLY_SHOW_DEFAULT } from '../common/utils/constants'
import { setSelectedOnlyShow } from './indicatorProfileSlice'
import { QueryParams } from '../common/utils/enum'

const OnlyShowDropdown = ({ chartType }) => {
  const { selectedOnlyShow, indicatorSpecificRegions } = useSelector(
    (state) => state.indicatorProfile
  )

  const { grouping } = useSelector((state) => state.common)

  const dispatch = useDispatch()
  const { setQueryParam } = useQueryParams()

  const handleOnlyShowChange = (event) => {
    dispatch(
      setSelectedOnlyShow({ selectedOnlyShow: event.target.value, chartType })
    )
    setQueryParam(QueryParams.OnlyShow, event.target.value)
  }

  return (
    <div className="tui__label_text tui__secondary_dropdown tui__chart_dropdown tui_input_select">
      <label id={`${chartType}-only-show`}>Only show</label>
      <select
        htmlFor={`${chartType}-only-show`}
        value={selectedOnlyShow[chartType]}
        onChange={(event) => handleOnlyShowChange(event)}
      >
        <option value={ONLY_SHOW_DEFAULT} className="ng-star-inserted">
          All countries & economies
        </option>
        {indicatorSpecificRegions.length > 0 && (
          <optgroup label="Regions">
            {indicatorSpecificRegions.map((region) => (
              <option
                key={region.code}
                value={region.code}
                className="ng-star-inserted"
              >
                {region.description}
              </option>
            ))}
          </optgroup>
        )}
        {grouping?.HCL_WB_INCOME?.length > 0 && (
          <optgroup label="Income groups">
            {grouping?.HCL_WB_INCOME?.map((incomeGroup) => (
              <option
                key={incomeGroup.id}
                value={incomeGroup.id}
                className="ng-star-inserted"
              >
                {incomeGroup.name}
              </option>
            ))}
          </optgroup>
        )}
      </select>
      <span className="select-arrow"></span>
    </div>
  )
}

export default OnlyShowDropdown
